 <template>
	<v-container class="noMargin">
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PROJECTS') !== -1">
			<v-flex lg12>
				<div class="pageTitle">
					<h2>PROJECT STATUS</h2>					
				</div>	
				<v-btn @click.prevent="fncAddProjectStatus" class="elevation-5" color="info"><i class="material-icons">add</i>Create Status</v-btn>
				<v-btn @click.prevent="fncReloadRoles" class="elevation-5" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
			</v-flex>
		</v-layout>		
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex'; 	

	export default {
		name: 'RoleHeader',
		data () {
			return {			
				
			}		
		  },
		methods: {
            fncAddProjectStatus() {
				var modalDetails = { title: 'Add Project Status', component: 'modal-project-status-add', mstate: true, params: {} };
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
          },
          fncReloadRoles() {
            this.$store.dispatch({
              type: 'fncPopulateProjectStatusList',
              reload: true
            })
          }
		},
		computed: {
			...mapGetters([			
				'objAuthorize'			
			])
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>